/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PhysicianViewModel } from './PhysicianViewModel'; 

export function getPhysicianOptions(id: string, onSuccess?: (result: PhysicianViewModel) => void) {
	return queryOptions({
		queryKey: ['physician', id],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/libraries/physicians/queries/getphysician/' + id;
			const resp = await axios.get<PhysicianViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(id)
	});
}